import useScrollReveal from "../../hooks/useScrollReveal";

const CycleCoconSection = () => {
  const phases = [
    {
      title: "Préparation",
      dates: "25 juillet → 7 septembre 2026",
      lines: ["Entrer progressivement.", "Ouvrir l'espace."],
    },
    {
      title: "Immersion — Valouse",
      dates: "7 → 11 septembre 2026",
      lines: ["Vivre la traversée.", "Au cœur."],
    },
    {
      title: "Intégration",
      dates: "mi-septembre → 31 octobre 2026",
      lines: ["Laisser s'ancrer.", "Incarner."],
    },
  ];

  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const blocksReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="cycle" className="py-24 sm:py-36 px-6 bg-[#E8D2B5]/50">
      <div className="max-w-3xl mx-auto">
        {/* En-tête — avec animation */}
        <div
          ref={headerReveal.ref}
          className={`text-center mb-20 sm:mb-24 space-y-6 scroll-reveal-slow ${headerReveal.isVisible ? "visible" : ""}`}
        >
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#3F2A24]">
            Le cycle COCON
          </h2>
          <div className="space-y-2">
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/70 italic">
              Trois temps.
            </p>
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/70 italic">
              Un même mouvement.
            </p>
          </div>
        </div>

        {/* 3 blocs — avec stagger */}
        <div
          ref={blocksReveal.ref}
          className="grid grid-cols-1 md:grid-cols-3 gap-0 items-stretch"
        >
          {phases.map((phase, i) => (
            <div
              key={i}
              className={`relative flex flex-col items-center text-center px-8 py-12 scroll-reveal scroll-reveal-delay-${i + 1} ${blocksReveal.isVisible ? "visible" : ""}`}
            >
              {/* Ligne de liaison entre les blocs (desktop) — plus longue, plus visible */}
              {i < phases.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-[1px] w-[1px] h-28 -translate-y-1/2 bg-[#3F2A24]/20" />
              )}
              {/* Ligne de liaison (mobile) — plus longue */}
              {i < phases.length - 1 && (
                <div className="md:hidden absolute bottom-0 left-1/2 -translate-x-1/2 w-20 h-[1px] bg-[#3F2A24]/20" />
              )}

              <h3 className="font-serif text-lg sm:text-xl text-[#3F2A24] mb-2.5">
                {phase.title}
              </h3>
              <p className="text-[13px] sm:text-sm tracking-[0.1em] text-[#7A5C10] font-medium mb-8">
                {phase.dates}
              </p>
              <div className="space-y-1.5">
                {phase.lines.map((line, j) => (
                  <p key={j} className="font-serif text-sm text-[#3F2A24]/70 italic leading-[1.8]">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ═══ CONSERVATION TEMPORAIRE — anciens styles CycleCoconSection ═══
 * Dates: text-xs tracking-[0.15em] text-[#C5A059] mb-6
 * Lignes desktop: h-16 bg-[#3F2A24]/15
 * Lignes mobile: w-12 bg-[#3F2A24]/15
 * En-tête: mb-16 space-y-4
 * Section: py-20 sm:py-28
 * Blocs: px-6 py-10
 * ═══ FIN CONSERVATION TEMPORAIRE ═══ */

export default CycleCoconSection;
